export default __webpack_public_path__ + "static/backdrop-bg-desktop-572de341aa52026005b0a6377b6d7aff.jpg";